import { IKhoiNganhActionTypes } from "../../action-types/category/IKhoiNganhActions";
import { IKhoiNganhReducer } from "../../reducer-model/category/IKhoiNganhReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IKhoiNganhReducer = {
    status: eReducerStatusBase.is_not_initialization,
    khoiNganhs: [],
};

export const khoiNganhReducer = (state: IKhoiNganhReducer = iniState, action: IKhoiNganhActionTypes): IKhoiNganhReducer => {
    switch (action.type) {
        case "KHOI_NGANH_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "KHOI_NGANH_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                khoiNganhs: action.payload,
            };
        case "KHOI_NGANH_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    }
};
